<div class="profile-menu-panel" role="menu" aria-label="Menú de usuario">
  @for (item of primarySection; track item.id) {
    <button
      type="button"
      class="profile-menu-panel__item profile-menu-panel__item--compact t-14-500-muted"
      role="menuitem"
      (click)="emitAction(item.id, $event)"
    >
      {{ item.label }}
    </button>
  }

  <div class="profile-menu-panel__divider" role="separator"></div>

  <button
    type="button"
    class="profile-menu-panel__item profile-menu-panel__item--row t-14-500-muted"
    role="menuitem"
    [attr.aria-expanded]="profileSubmenuExpanded()"
    aria-controls="profile-submenu"
    id="profile-menu-trigger"
    (click)="toggleProfileSubmenu($event)"
  >
    <span>Perfil</span>
    <img
      src="assets/icons/ico_angle_right.svg"
      width="16"
      height="16"
      alt=""
      aria-hidden="true"
      class="profile-menu-panel__chevron"
      [class.profile-menu-panel__chevron--open]="profileSubmenuExpanded()"
    />
  </button>

  @if (profileSubmenuExpanded()) {
    <div
      id="profile-submenu"
      class="profile-menu-panel__submenu"
      role="group"
      aria-labelledby="profile-menu-trigger"
    >
      <button
        type="button"
        class="profile-menu-panel__item profile-menu-panel__item--submenu t-14-500-muted"
        role="menuitem"
        (click)="emitAction('accounts', $event)"
      >
        Cuentas bancarias
      </button>
      <button
        type="button"
        class="profile-menu-panel__item profile-menu-panel__item--submenu t-14-500-muted"
        role="menuitem"
        (click)="emitAction('support', $event)"
      >
        Preguntas frecuentes
      </button>
      <button
        type="button"
        class="profile-menu-panel__item profile-menu-panel__item--submenu t-14-500-muted"
        role="menuitem"
        (click)="emitAction('terms', $event)"
      >
        Términos y Condiciones
      </button>
      <button
        type="button"
        class="profile-menu-panel__item profile-menu-panel__item--submenu t-14-500-muted"
        role="menuitem"
        (click)="emitAction('unsubscribe', $event)"
      >
        Darse de baja
      </button>
    </div>
  }

  <div class="profile-menu-panel__divider" role="separator"></div>

  <button
    type="button"
    class="profile-menu-panel__item profile-menu-panel__item--row profile-menu-panel__item--logout t-14-500-muted"
    role="menuitem"
    (click)="emitAction('logout', $event)"
  >
    <img src="assets/icons/ic_sign_out.svg" width="20" height="20" alt="" aria-hidden="true" />
    <span>Cerrar sesión</span>
  </button>
</div>
